<div class="container-fluid">
    <div *ngIf="facility.activeFlag === false">
        <div class="row mt-16">
            <div class="col-md-2">

            </div>
            <div class="center col-md-10">
                <p class="text-danger font-weight-bold">Facility ID {{facility.productionFacilityId}} is disabled
                    permanantly</p>
            </div>
        </div>
    </div>
    <app-googlemaps [buttonTrigger]="mapsPopupVisible" [isReadOnly]="true" [Coordinates]="Coordinates"
        (setmapsPopupVisibility)="setmapsPopupVisibility($event)">
    </app-googlemaps>
    <div *ngIf="facility.activeFlag === true || facility.activeFlag === undefined || facility.activeFlag === null">
        <div class="col-md-12">
            <h4 *ngIf="isNewFacility" class="ap-green">Add Facility (Prospect)</h4>
            <h4 *ngIf="!isNewFacility" class="ap-green">Edit Facility</h4>
        </div>
        <div class="form-group col-md-12">
            <label class="text-danger font-weight-bold" for="siteDescription">Site Description: </label>
            <label class="text-danger font-weight-bold" name="siteDescription">&nbsp;&nbsp;{{facility.siteDescription}},&nbsp;
            </label><label class="text-danger font-weight-bold cursor-pointer"
                (click)="onSiteIdClicked()">{{facility.siteId}}</label>
            <div>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold" for="siteDescription">Facility ID:
                </label>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold"
                    name="siteDescription">&nbsp;&nbsp;{{facility.productionFacilityId}}</label>
            </div>
            <div>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold" for="ModifiedBy">Modified By:
                </label>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold"
                    name="ModifiedBy">&nbsp;&nbsp;{{facility.modifiedBy}}</label>
            </div>
            <div>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold" for="ModifiedDate">Modified Date:
                </label>
                <label *ngIf="!isNewFacility" class="text-danger font-weight-bold"
                    name="ModifiedDate">&nbsp;&nbsp;{{facility.modifiedDate | date: "MM/dd/yyyy h:mm:ss a"}}</label>
            </div>
            <dx-button class="ap-blue-btn" text="View On Map" (onClick)="mapview()">
            </dx-button>
        </div>
        <div class="col-md-12">
            <form validationGroup="facilityData" #facilityForm="ngForm" (ngSubmit)="Save()" class="form-horizontal"
                autocomplete="off" showValidationSummary="true">
                <div class="row mb-2">
                    <div class="col-md-10">
                        <div class="d-flex justify-content-center">
                            <dx-radio-group [dataSource]="facilityTypes" value="facility.facilityType"
                                [(ngModel)]="facility.facilityType" name="facilityType" layout="horizontal">
                            </dx-radio-group>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <facility-details (loadPanelVisibleEvent)="changeLoadPanelIndicator($event)"
                    [isNewFacility]="isNewFacility" [industrialGasUOMs]="industrialGasUOMs" [facility]="facility"
                    [facilityType]="facility.facilityType"></facility-details>


                <div class="row mt-4">
                    <div class="col-md-12">
                        <div class="d-flex justify-content-center">
                            <dx-radio-group [dataSource]="facilityStatuses" value="facility.facilityStatus"
                                [(ngModel)]="facility.facilityStatus" name="facilityStatus" layout="horizontal">
                            </dx-radio-group>
                        </div>
                    </div>

                </div>

                <div class="row mt-1 mb-3">
                    <div class="col-md-12 text-center">
                        <div class="dx-fieldset">
                            <dx-validation-summary id="summary"></dx-validation-summary>
                        </div>
                        <dx-button [useSubmitBehavior]="true" text="Save"
                            class="ap-green-btn mr-1 mt-1 ml-2 px-5">
                        </dx-button>
                        <dx-button text="Discard Close" class="ap-discard-button mr-1 mt-1 ml-2 px-5"
                            (onClick)="Discard()">
                        </dx-button>
                        <dx-button *ngIf="!isNewFacility" text="Delete"
                            class="ap-delete-button mr-1 mt-1 ml-2 px-5" (onClick)="Delete()">
                        </dx-button>
                    </div>
                </div>
            </form>

        </div>
    </div>

    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="isLoadPanelVisible" [showPane]="true"
        [shading]="true" [closeOnOutsideClick]="false">
    </dx-load-panel>

    <dx-toast *ngIf="isToastVisible" [message]="toastMessage" [(visible)]="isToastVisible" [type]="" position="top">
    </dx-toast>